import {
  actions,
  Button,
  Icon,
  KeyMap,
  Tooltip,
  useNavigationContext,
} from '@infotech-soe/erp-ui-kit';
import React, { memo, useCallback, useMemo } from 'react';
import { useIntl } from 'react-intl';

import { OPEN_MENU_HOTKEY } from './constants';
import { useMenuContext } from './MenuContext';
import { toggleButtonMessages } from './messages';
import Searchbar from './Searchbar';
import { useToggleButtonStyles } from './styles';

const TOGGLE_BUTTON_NAME = 'menu-toggle-button';

const MenuToggleButton = (): React.JSX.Element => {
  const classes = useToggleButtonStyles();
  const { formatMessage } = useIntl();

  const { collapsed, onToggleMenu } = useMenuContext();
  const { active, onActivate, onRegister } = useNavigationContext();

  const handleClick = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      const isKeyboardEvent = 'detail' in e && e.detail === 0;
      if (collapsed || !isKeyboardEvent) {
        onActivate(e, TOGGLE_BUTTON_NAME);
        onToggleMenu();
      }
    },
    [collapsed, onActivate, onToggleMenu]
  );

  const label = useMemo(
    () =>
      formatMessage(
        collapsed
          ? toggleButtonMessages.openAppMenu
          : toggleButtonMessages.closeAppMenu,
        { hotkey: collapsed ? OPEN_MENU_HOTKEY : KeyMap[actions.CANCEL] }
      ),
    [collapsed, formatMessage]
  );

  return (
    <Tooltip label={label} placement="right">
      <Button
        className={classes.button}
        ref={(el: HTMLButtonElement) =>
          onRegister(el, TOGGLE_BUTTON_NAME, !collapsed)
        }
        tabIndex={active === TOGGLE_BUTTON_NAME ? 0 : -1}
        onClick={handleClick}
      >
        <Icon name="sidebar" size={24} />
        <Searchbar />
      </Button>
    </Tooltip>
  );
};

export default memo(MenuToggleButton);
